import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNumeric, isUuid, createCustomPropType } from '../../../js/app/react/validators';
import Loading from '../Loading/LoadingView';
import Tooltip from '../../CommonComponents/Tooltip';

const CHANGE_FIELDS = ['fpId', 'goalId', 'clientId', 'url'];

class AllPlanEdits extends Component {
  componentDidUpdate(prevProps) {
    const { fetchData, clientId, fpId, goalId, url } = this.props;
    if (CHANGE_FIELDS.some(field => prevProps[field] !== this.props[field])) {
      fetchData(clientId, fpId, goalId, url);
    }
  }

  render() {
    const {
      setCurrentViewId,
      removeWhatIf,
      removeAllWhatIfs,
      goalId,
      fpId,
      loading,
      url,
      clientId,
      whatIfs,
      numberOfEdits,
      closeActiveEdits,
    } = this.props;
    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-section active-edits what-ifs-layout-header-plan-edits">
          <h3>
            Applied What-Ifs
            <Tooltip
              tag="i"
              role="button"
              tabIndex={0}
              tooltipchildren="Clears all applied What-Ifs"
              orientation="left"
              onKeyDown={() => {}}
              onClick={removeAllWhatIfs(clientId, fpId, goalId, url, whatIfs)}
              className="fa fa-times-circle what-ifs-remove-all"
            />
            <span className="all-plan-edits-number-of-edits">{numberOfEdits}</span>
          </h3>
        </div>
        <ul className="what-ifs-submenu expanded what-ifs-layout-content">
          {whatIfs.map(whatIf => (
            <li key={whatIf.id} className="what-ifs-subsection">
              <button
                type="button"
                className="is-applied"
                onClick={setCurrentViewId(clientId, goalId, whatIf.id)}
              >
                {whatIf.question}
              </button>
              <i
                role="button"
                aria-label="Clears all applied what ifs"
                tabIndex={0}
                onKeyDown={() => {}}
                onClick={removeWhatIf(clientId, fpId, goalId, url, whatIf)}
                className="fa fa-times-circle what-ifs-remove"
              />
            </li>
          ))}
        </ul>
        <button
          type="button"
          onClick={closeActiveEdits(clientId, goalId)}
          className="bg-transparent white close-button what-ifs-menu-layout-footer"
        >
          Close Applied What-Ifs
        </button>
      </div>
    );
  }
}

AllPlanEdits.defaultProps = {
  whatIfs: [],
};

AllPlanEdits.propTypes = {
  loading: PropTypes.bool.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  url: PropTypes.string.isRequired,
  numberOfEdits: PropTypes.number.isRequired,
  whatIfs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      question: PropTypes.string.isRequired,
    }),
  ),
  setCurrentViewId: PropTypes.func.isRequired,
  removeWhatIf: PropTypes.func.isRequired,
  closeActiveEdits: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  removeAllWhatIfs: PropTypes.func.isRequired,
};

export default AllPlanEdits;
